import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Subscription } from 'rxjs/Subscription';

import { NativeWindowService } from '../../../services/native-window.service';
import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-modal-wrapper',
	templateUrl: './modal-wrapper.component.html',
	styleUrls: ['./modal-wrapper.component.css'],
	exportAs: 'modal-wrapper'
})
export class ModalWrapperComponent implements OnInit{
	@ViewChild('mwModal') modalWrapperModal: ModalDirective;
	@Input() modalInput: any;
	@Input() writePermission: boolean = false;
	@Input() datiRettifica: string = '';
	@Output() modalOutput = new EventEmitter();
	@Output() trasmettiRettifica = new EventEmitter();
	modalType: string = '';

	modalHeight: string;
	nativeHeight: number;
	nativeHeightSync: Subscription;
	nativeWidth: number;
	nativeWidthSync: Subscription;

	constructor(private nativeWindowService: NativeWindowService, private dataService: DataService,) {
	}

	ngOnInit(){
		this.nativeHeightSync = this.nativeWindowService.nativeHeight$.subscribe(
			nativeHeight => {
				this.nativeHeight = nativeHeight - Math.round(nativeHeight * 11 / 100);
				if(this.nativeHeight < 0){
					this.nativeHeight = 0;
				}
				//console.log("nativeHeight", this.nativeHeight);
			});
		this.nativeWidthSync = this.nativeWindowService.nativeWidth$.subscribe(
			nativeWidth => {
				this.nativeWidth = nativeWidth;
				if(this.nativeWidth < 0){
					this.nativeWidth = 0;
				}
				//console.log("nativeWidth", this.nativeWidth);
			});
	}

	ngOnChanges(changes: any){
		console.log('CHANGE WRAPPER', changes);
		if(changes.datiRettifica) {
			console.log('CHANGE DATI RETTIFICA WRAPPER', this.datiRettifica);
		}
	}

	show(modalType: any, modalInput?: any) {
		console.debug("MODALWRAPPER|SHOW", modalType, this.modalInput, modalInput);
		if(modalInput){
			if(modalInput.height == 'native'){
				this.modalHeight = this.nativeHeight + 'px';
			}else if(modalInput.height == 'fluid'){
				this.modalHeight = 100 + '%';
			}else{
				this.modalHeight = 100 + '%';
			}
		}else{
			this.modalHeight = this.nativeHeight + 'px';
		}
		console.log("MODALWRAPPER|SHOW - modalHeight", this.modalHeight);
		this.modalType = modalType;
		this.modalWrapperModal.show();
	}

	hide() {
		console.debug("MODALWRAPPER|HIDE");
		this.modalType = '';
		this.modalWrapperModal.hide();
	}

	getInnerEvents(event: any) {
		console.debug("innerEvent:", event);
		let what: any = null;
		let key: any = null;
		let localFilters = [];
		let localSets = {};

		if(event.salvaContribuente) {
			this.modalInput['title'] = event.title;
			this.modalInput['subtitle'] = event.subtitle;
		}

		if(event.flowEvent){
			console.debug('flowEvent');
			this.modalOutput.emit(event.data);
		}

		if(event.innerFind) {
			this.modalOutput.emit(event.content);
		}

		if(event.inserisciPratica){
			localSets = {"selectedRow": event.selectedRow };
			this.dataService.insert("pratiche", localSets, true, (error,res) => {
				if(error) {
					//this.dataService.openMessage('INSERIMENTO PRATICA','si è verificato un errore');
				}
				if(res){
					console.log("response:", res);
				}
			});
		}

		if(event.modificaPratica){
			localSets = {"selectedRow": event.selectedRow };
			this.dataService.update("pratiche", localFilters, localSets, true, (error,res) => {
				if(error) {
					//this.dataService.openMessage('MODIFICA PRATICA','si è verificato un errore');
				}
				if(res){
					console.log("response:", res);
				}
			});
		}

		if(event.rettificaPratica) {
			console.log('event rettifica');
			this.modalOutput.emit(event);
		}

		if(event.cambiaStato){
			localSets = {"stato_id": event.id_stato, "uid":  event.uid, "mantieni_dati": false };
			this.dataService.runQuery("cambia_stato", localFilters, localSets, true, (error,res) => {
				if(error) {
					//this.dataService.openMessage('CAMBIA STATO','si è verificato un errore');
				}
			});
		}

		if(event.restorePratica){
			localSets = {"log_pratica_id": event.id_log_pratica, "uid":  event.uid };
			this.dataService.runQuery("restore_pratica", localFilters, localSets, true, (error,res) => {
				if(error) {
					//this.dataService.openMessage('RESTORE PRATICA','si è verificato un errore');
				}
			});
		}

		if(event.aggiungiPagamento) {
			console.log('event aggiungiPagamento');
			this.modalOutput.emit(event);
		}

		if(event.aggiungiNotifica) {
			localSets = event.setValue;
			this.dataService.updateNotifica(event.uid, localFilters, localSets, true, (error,res) => {
				if(error) {
					//this.dataService.openMessage('AGGIORNAMENTO NOTIFICA','si è verificato un errore');
				}
			});
		}

		if(event.aggiungiNotifica) {
			console.log('event aggiungiNotifica');
			this.modalOutput.emit(event);
		}

		if(event.openNewRate){
			console.log('event openNewRate');
			this.show(event.modalType);
		}

		if(event.hide) {
			this.hide();
		}
	}

	gestisciRettifica(event) {
		console.log('GESTISCI RETTIFICA',event);
		this.trasmettiRettifica.emit(event);
	}
}
